export default {
  "content": "<path d=\"M0 0h32v32H0z\" fill=\"none\"/><path d=\"M16.727 17.775v-3.219h10.848c.106.561.161 1.225.161 1.943 0 2.415-.66 5.402-2.788 7.529-2.07 2.155-4.714 3.305-8.217 3.305-6.493 0-11.953-5.289-11.953-11.782S10.238 3.77 16.731 3.77c3.592 0 6.151 1.409 8.073 3.246l-2.271 2.271c-1.379-1.293-3.246-2.299-5.805-2.299-4.741 0-8.45 3.821-8.45 8.562s3.708 8.562 8.45 8.562c3.075 0 4.827-1.235 5.949-2.357.91-.91 1.509-2.21 1.745-3.985z\" fill=\"#3F4450\"/>",
  "attrs": {
    "viewBox": "0 0 32 32",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};